import React from "react";
import { useNavigate } from "react-router-dom";

const TermsAndCondition = () => {
   const navigate = useNavigate();
      const handleNavigate = () => {
        navigate(-1);
      };
  return (
    <div className="">
      <div className="WrapperBox">
        <div className="Small-Wrapper" style={{ padding: 40 }}>
          <div className="TitleBox">
            <h4 className="Title">Terms &amp; Conditions</h4>
            <button type="submit" className="Button" onClick={handleNavigate}>
              <i className="fa fa-long-arrow-left" aria-hidden="true" /> Back
            </button>
          </div>
          <div>
            <p>
              By accessing and using the Learn2Prospuh platform, you agree to
              the following terms and conditions:
            </p>
            <ul>
              <li>
                {" "}
                <strong>1. Eligibility:</strong> Learn2Prospuh is available to
                students in grades 7-12 in The Bahamas. Users must create an
                account to access courses, challenges, and rewards.
              </li>
              <br />
              <li>
                {" "}
                <strong>2. Use of Content:</strong> All content, including
                courses, challenges, and resources, is for educational purposes
                only and may not be reproduced, distributed, or modified without
                permission.
              </li>
              <br />
              <li>
                {" "}
                <strong>3. Participation in Challenges:</strong> Students who
                participate in challenges must adhere to the rules provided for
                each competition. Prizes will be awarded based on eligibility
                and fair competition practices.
              </li>
              <br />
              <li>
                {" "}
                <strong>4. Account Responsibility:</strong> Users must provide
                accurate information when creating an account and are
                responsible for keeping their login credentials secure.
              </li>
              <br />
              <li>
                {" "}
                <strong>5. Data Protection:</strong> Learn2Prospuh collects
                minimal personal data necessary for account creation and user
                engagement. By using the platform, you consent to the collection
                and use of data as outlined in our Privacy Policy.
              </li>
              <br />
              <li>
                {" "}
                <strong>6. Code of Conduct:</strong> Users must engage
                respectfully with other students, mentors, and educators. Any
                form of inappropriate behavior, harassment, or cheating may
                result in account suspension.
              </li>
              <br />
              <li>
                {" "}
                <strong>7. Changes to Terms:</strong> Learn2Prospuh reserves the
                right to modify these Terms &amp; Conditions at any time.
                Continued use of the platform after updates constitutes
                acceptance of the new terms.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
